
import { NavLink } from "@/lib/router-compat";
import { cn } from "@/lib/utils";
import { useState, useRef } from "react";

interface ThemeLogoProps {
  className?: string;
}

const ThemeLogo = ({ className }: ThemeLogoProps) => {

  const [clickCount, setClickCount] = useState(0);
  const [isWiggling, setIsWiggling] = useState(false);
  const audioRef = useRef<HTMLAudioElement | null>(null);

  const handleClick = (e: React.MouseEvent) => {
    // Trigger wiggle animation
    setIsWiggling(true);
    setTimeout(() => setIsWiggling(false), 300);
    
    const newCount = clickCount + 1;
    
    if (newCount >= 15) {
      e.preventDefault();
      setClickCount(0); // Reset for next time
      // Play the funny audio
      if (audioRef.current) {
        audioRef.current.currentTime = 0; // Reset audio to start
        audioRef.current.play();
      }
    } else {
      setClickCount(newCount);
      e.preventDefault(); // Prevent navigation until triggered
    }
  };
  
  return (
    <>
      <audio ref={audioRef} src="/audio/funny.mp3" />
      <NavLink
        to="/"
        onClick={handleClick}
        className="flex items-center transition-transform hover:scale-[1.02] active:scale-[0.98]"
      >
        <img
          src="/logo-dark.svg"
          alt="Byteline - Technology News and Market Intelligence"
          width={2087}
          height={580}
          className={cn(
            "h-10 w-auto ml-[17px]",
            isWiggling && "animate-wiggle",
            className
          )}
        />
      </NavLink>
    </>
  );
};

export default ThemeLogo;
